import React, { useState, useEffect } from 'react';
import { Document, Packer, Paragraph, HeightRule, TextRun, Header, HorizontalPositionRelativeFrom, SimpleField, PageNumber, NumberFormat, HorizontalPositionAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, TextWrappingType, Table, Footer, TableRow, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign } from "docx";
import { saveAs } from "file-saver";
import RelaysTwoUpdate from "./RelaysTwoUpdate";
import './RelaysThree.css';
import { API_URL } from "./API";


function FunctionalChecks({ savedGeneralData, goBack, updateFormData, formData, clearAllFormData }) {
  const convertDictToArray = (dict, labels) => {
    if (!dict || Array.isArray(dict) || typeof dict !== 'object') {
      return labels.map(() => "");
    }
    const byIndex = labels.map((_, idx) => {
      const k1 = String(idx + 1);
      if (dict.hasOwnProperty(k1)) return dict[k1] ?? '';
      if (dict.hasOwnProperty(idx)) return dict[idx] ?? '';
      return undefined;
    });
    return labels.map((label, idx) => {
      if (byIndex[idx] !== undefined) return byIndex[idx];
      if (dict.hasOwnProperty(label)) return dict[label] ?? '';
      return '';
    });
  };
  const functionalChecksData = [
    "Wiring checks",
    "Correct operation of appropriate indicator /aux. relay",
    "Correct intiation of alarm contacts",
    "Correct circuit breaker tripping contacts",
    "Relay cover properly fixing",
    "Correct operating reset switch",
    "Relay Draw out conditions CT shorting link should be short",
    "All Binary I/O's and LED indications Checked and found ok"
  ];

  const checkListData = [
    "Check the healthiness of fuses, links, MCCB, Switches, indication lamps, push buttons, space heater & illumination circuit",
    "Check broken glass, switch handle, lamp cover etc.",
    "Check all electrical interlock as per scheme.",
    "Check Mounting of all components i.e. Relays, Meters etc.",
    "Check the fuses for correct rating & mounting.",
    "Checking of breaker for free movement.",
    "Scheme checking as per approved drawings.",
    "Checking of all closing and tripping interlocks",
    "Checking of all contacts used for external system."
  ];


  const [functionalValues, setFunctionalValues] = useState(() => {
    try {
      const savedFunctionalData = localStorage.getItem('updateFunctionalChecksData');
      if (savedFunctionalData) {
        const parsed = JSON.parse(savedFunctionalData);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      }

      if (formData?.functionalChecksData && Array.isArray(formData.functionalChecksData)) {
        return formData.functionalChecksData;
      }

      if (savedGeneralData?.test_data?.functionalChecksData) {
        const fcd = savedGeneralData.test_data.functionalChecksData;
        if (Array.isArray(fcd)) return fcd;
        if (typeof fcd === 'object') return convertDictToArray(fcd, functionalChecksData);
      }

      const updateDataStr = localStorage.getItem('updateReportData');
      if (updateDataStr) {
        const updateData = JSON.parse(updateDataStr);
        const fcd = updateData?.test_data?.functionalChecksData || updateData?.test_data?.f_functionalChecksData;
        if (Array.isArray(fcd)) return fcd;
        if (typeof fcd === 'object') return convertDictToArray(fcd, functionalChecksData);
      }
    } catch (error) {
      console.error("Error initializing functional values:", error);
    }


    return functionalChecksData.map(() => "");
  });

  const [checkListValues, setCheckListValues] = useState(() => {
    try {
      const savedCheckListData = localStorage.getItem('updateCheckListData');
      if (savedCheckListData) {
        const parsed = JSON.parse(savedCheckListData);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      }

      if (formData?.checkListData && Array.isArray(formData.checkListData)) {
        return formData.checkListData;
      }

      if (formData?.relays_checkList_Data && Array.isArray(formData.relays_checkList_Data)) {
        return formData.relays_checkList_Data;
      }

      if (savedGeneralData?.test_data?.relays_checkList_Data) {
        const cld = savedGeneralData.test_data.relays_checkList_Data;
        if (Array.isArray(cld)) return cld;
        if (typeof cld === 'object') return convertDictToArray(cld, checkListData);
      }
      if (savedGeneralData?.test_data?.checkListData) {
        const cld = savedGeneralData.test_data.checkListData;
        if (Array.isArray(cld)) return cld;
        if (typeof cld === 'object') return convertDictToArray(cld, checkListData);
      }

      const updateDataStr = localStorage.getItem('updateReportData');
      if (updateDataStr) {
        const updateData = JSON.parse(updateDataStr);
        const cld = updateData?.test_data?.relays_checkList_Data || updateData?.test_data?.checkListData || updateData?.test_data?.g_checkListData;
        if (Array.isArray(cld)) return cld;
        if (typeof cld === 'object') return convertDictToArray(cld, checkListData);
      }
    } catch (error) {
      console.error("Error initializing checklist values:", error);
    }


    return checkListData.map(() => "");
  });



  const [showBackPage, setShowBackPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [allFormData, setAllFormData] = useState({
    formData: {},
    rows: [],
    generalInspection: {},
    settings: {},
    operationalTimeData: {}
  });




  useEffect(() => {
    try {
      localStorage.setItem('updateFunctionalChecksData', JSON.stringify(functionalValues));
    } catch (error) {
      console.error("Error saving functional checks to localStorage:", error);
    }
  }, [functionalValues]);

  useEffect(() => {
    try {
      localStorage.setItem('updateCheckListData', JSON.stringify(checkListValues));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  }, [checkListValues]);


  const loadAllFormDataFromStorage = () => {
    try {
      const allFormData = {
        formData: {},
        rows: [],
        generalInspection: {},
        settings: {},
        operationalTimeData: {},
        functionalChecksData: functionalValues,
        checkListData: checkListValues
      };


      const mainFormData = localStorage.getItem('updateRelayInspectionData');
      if (mainFormData) {
        const parsedMainFormData = JSON.parse(mainFormData);
        allFormData.formData = parsedMainFormData;
      }


      const rowsData = localStorage.getItem('protectionFunctionsData');
      if (rowsData) {
        allFormData.rows = JSON.parse(rowsData);
      }

      const generalInspectionData = localStorage.getItem('generalInspectionData');
      if (generalInspectionData) {
        allFormData.generalInspection = JSON.parse(generalInspectionData);
      }

      const settingsData = localStorage.getItem('updateRelaySettingsData');
      if (settingsData) {
        allFormData.settings = JSON.parse(settingsData);
      }

      const operationalTimeData = localStorage.getItem('updateOperationalTimeData');
      if (operationalTimeData) {
        allFormData.operationalTimeData = JSON.parse(operationalTimeData);
      }

      return allFormData;
    } catch (error) {
      console.error("Error loading form data from localStorage:", error);
      return {
        formData: {},
        rows: [],
        generalInspection: {},
        settings: {},
        operationalTimeData: {},
        functionalChecksData: functionalValues,
        checkListData: checkListValues
      };
    }
  };

  const handleFunctionalChange = (index, value) => {
    const newValues = Array.isArray(functionalValues) ? [...functionalValues] : [];
    newValues[index] = value;
    setFunctionalValues(newValues);


    try {
      localStorage.setItem('updateFunctionalChecksData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving functional checks to localStorage:", error);
    }
  };

  const handleCheckListChange = (index, value) => {
    const newValues = Array.isArray(checkListValues) ? [...checkListValues] : [];
    newValues[index] = value;
    setCheckListValues(newValues);


    try {
      localStorage.setItem('updateCheckListData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  };

  useEffect(() => {
    const autoSave = () => {
      try {
        const formDataToSave = {
          functionalValues: functionalValues,
          checkListValues: checkListValues,
          projectDetails: projectDetails,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('relays_autosave', JSON.stringify(formDataToSave));
      } catch (error) {
        console.error("Auto-save failed:", error);
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000);

    return () => clearInterval(autoSaveInterval);
  }, [functionalValues, checkListValues, projectDetails]);


  useEffect(() => {
    try {
      const autoSavedData = localStorage.getItem('relays_autosave');
      if (autoSavedData) {
        const parsedData = JSON.parse(autoSavedData);
        if (parsedData.functionalValues && Array.isArray(parsedData.functionalValues)) {
          setFunctionalValues(parsedData.functionalValues);
        }
        if (parsedData.checkListValues && Array.isArray(parsedData.checkListValues)) {
          setCheckListValues(parsedData.checkListValues);
        }
        if (parsedData.projectDetails) {
          setProjectDetails(prev => ({
            ...prev,
            ...parsedData.projectDetails
          }));
        }
      }
    } catch (error) {
      console.error("Error loading auto-saved data:", error);
    }
  }, []);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    const handleUnload = () => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [formSubmitted]);

  const clearAllStorageData = () => {
    try {
      const keysToRemove = [
        'updateFunctionalChecksData',
        'updateCheckListData',
        'updateRelayInspectionData',
        'protectionFunctionsData',
        'generalInspectionData',
        'updateRelaySettingsData',
        'updateOperationalTimeData',
        'createReportData',
        'navbarData',
        'relayInspectionReportPdf',
        'relays_autosave'
      ];

      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });

      console.log("All form data cleared from localStorage");
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  };

  const resetAllFormStates = () => {
    setFunctionalValues(functionalChecksData.map(() => ""));
    setCheckListValues(checkListData.map(() => ""));

    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });

    setAllFormData({
      formData: {},
      rows: [],
      generalInspection: {},
      settings: {},
      operationalTimeData: {}
    });

    setFormSubmitted(false);
    setErrorMessage("");
    setSuccessMessage("");
    setShowBackPage(false);

    if (clearAllStorageData && typeof clearAllStorageData === 'function') {
      clearAllStorageData();
    }
  };

  const validateAndCleanData = (data) => {
    const cleanData = {};

    cleanData.equipment_name = String(data.equipment_name || "Relays");
    cleanData.test_date = String(data.test_date || new Date().toISOString().split('T')[0]);
    cleanData.category_name = String(data.category_name || "Category");
    cleanData.subcategory_name = String(data.subcategory_name || "Subcategory");
    cleanData.sub_project_name = String(data.sub_project_name || "Project");
    cleanData.location = String(data.location || "");

    let projectId = data.project_id;
    if (typeof projectId === 'string') {
      projectId = parseInt(projectId.replace(/\D/g, ''));
    }
    cleanData.project_id = Number.isInteger(projectId) && projectId > 0 ? projectId : 1;

    if (data.report_file && typeof data.report_file === 'object') {
      cleanData.report_file = {
        report_pdf: String(data.report_file.report_pdf || ""),
        filename: String(data.report_file.filename || `Relay_Test_Report_${Date.now()}.pdf`),
        file_type: String(data.report_file.file_type || "application/pdf")
      };
    }

    if (data.test_data && typeof data.test_data === 'object') {
      cleanData.test_data = {
        formData: data.test_data.formData || {},
        rows: data.test_data.rows || [],
        generalInspection: data.test_data.generalInspection || {},
        settings: data.test_data.settings || {},
        operationalTimeData: data.test_data.operationalTimeData || {},
        functionalChecksData: Array.isArray(data.test_data.functionalChecksData) ? data.test_data.functionalChecksData : [],
        checkListData: Array.isArray(data.test_data.checkListData) ? data.test_data.checkListData : []
      };
    }

    return cleanData;
  };

  const createMeaningfulDictionary = (dataArray, descriptionsArray, keyPrefix) => {
    const dictionary = {};

    dataArray.forEach((value, index) => {
      if (index < descriptionsArray.length) {

        const description = descriptionsArray[index];
        const key = `${keyPrefix}_${index + 1}_${description.toLowerCase()
          .replace(/[^a-zA-Z0-9\s]/g, '')
          .replace(/\s+/g, '_')
          .substring(0, 50)}`;

        dictionary[key] = {
          description: description,
          value: value || "",
          index: index
        };
      }
    });

    return dictionary;
  };


  const createSimpleDictionary = (dataArray, descriptionsArray) => {
    const dictionary = {};


    const valuesArray = Array.isArray(dataArray) ? dataArray : [];
    const descriptionsArr = Array.isArray(descriptionsArray) ? descriptionsArray : [];


    descriptionsArr.forEach((description, index) => {

      const cleanDescription = String(description).trim();

      const value = index < valuesArray.length ? String(valuesArray[index] || "").trim() : "";


      if (cleanDescription) {
        dictionary[cleanDescription] = value;
      }
    });

    return dictionary;
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setIsLoading(true);
    setErrorMessage("");

    try {

      const freshRelayData = localStorage.getItem('updateRelayInspectionData');
      const freshSettingsData = localStorage.getItem('updateRelaySettingsData');
      const freshOperationalData = localStorage.getItem('updateOperationalTimeData');
      const freshFunctionalData = localStorage.getItem('updateFunctionalChecksData');
      const freshCheckListData = localStorage.getItem('updateCheckListData');




      let savedRelayData = {};
      let savedSettingsData = {};
      let savedOperationalData = {};
      let savedFunctionalData = [];
      let savedCheckListData = [];

      try {
        savedRelayData = freshRelayData ? JSON.parse(freshRelayData) : {};
        console.log("✓ Parsed Relay Data:", savedRelayData);
      } catch (e) {
        console.error("❌ Error parsing Relay data:", e);
      }

      try {
        savedSettingsData = freshSettingsData ? JSON.parse(freshSettingsData) : {};
        console.log("✓ Parsed Settings Data:", savedSettingsData);
      } catch (e) {
        console.error("❌ Error parsing Settings data:", e);
      }

      try {
        savedOperationalData = freshOperationalData ? JSON.parse(freshOperationalData) : {};
        console.log("✓ Parsed Operational Data:", savedOperationalData);
      } catch (e) {
        console.error("❌ Error parsing Operational data:", e);
      }

      try {
        savedFunctionalData = freshFunctionalData ? JSON.parse(freshFunctionalData) : functionalValues;
        console.log("✓ Parsed Functional Data:", savedFunctionalData);
      } catch (e) {
        console.error("❌ Error parsing Functional data:", e);
        savedFunctionalData = functionalValues;
      }

      try {
        savedCheckListData = freshCheckListData ? JSON.parse(freshCheckListData) : checkListValues;
        console.log("✓ Parsed CheckList Data:", savedCheckListData);
      } catch (e) {
        console.error("❌ Error parsing CheckList data:", e);
        savedCheckListData = checkListValues;
      }


      const finalFunctionalData = Array.isArray(savedFunctionalData) ? savedFunctionalData : functionalValues;
      const finalCheckListData = Array.isArray(savedCheckListData) ? savedCheckListData : checkListValues;

      console.log("Final Arrays:");
      console.log("- Functional Array:", finalFunctionalData);
      console.log("- CheckList Array:", finalCheckListData);


      const wordBlob = await generateWordBlob();

      const reader = new FileReader();
      reader.readAsDataURL(wordBlob);

      reader.onloadend = async () => {
        try {
          const dataUrl = reader.result;
          const base64Word = typeof dataUrl === 'string' && dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
          localStorage.setItem('relayTestReportWord', base64Word);


          let reportId = null;


          if (savedGeneralData?.report_id) {
            reportId = savedGeneralData.report_id;
            console.log("✓ Report ID from savedGeneralData:", reportId);
          } else if (savedGeneralData?.id) {
            reportId = savedGeneralData.id;
            console.log("✓ Report ID from savedGeneralData.id:", reportId);
          } else {
            try {
              const updateReportData = localStorage.getItem('updateReportData');
              if (updateReportData) {
                const parsed = JSON.parse(updateReportData);
                reportId = parsed.report_id || parsed.id;
                console.log("✓ Report ID from updateReportData:", reportId);
              }
            } catch (error) {
              console.error("Error getting report ID from localStorage:", error);
            }
          }

          if (!reportId) {
            throw new Error("Report ID is required for update operation");
          }

          console.log("=== Using Report ID:", reportId, "===");


          const currentDate = new Date().toISOString().split('T')[0];

          const resolveProjectId = () => {

            try {
              const upd = JSON.parse(localStorage.getItem('updateReportData') || 'null');
              const id = upd?.project_id || upd?.report?.project_id || upd?.project?.project_id;
              const n = parseInt(typeof id === 'string' ? id.replace(/\D/g, '') : id);
              if (!isNaN(n) && n > 0) return n;
            } catch { }


            const sg = savedGeneralData || {};
            const sgId = sg.project_id || sg?.projectData?.project_id || sg?.formData?.project_id;
            {
              const n = parseInt(typeof sgId === 'string' ? String(sgId).replace(/\D/g, '') : sgId);
              if (!isNaN(n) && n > 0) return n;
            }



            try {
              const nav = JSON.parse(localStorage.getItem('navbarData') || 'null');
              const n = parseInt(typeof nav?.project_id === 'string' ? nav.project_id.replace(/\D/g, '') : nav?.project_id);
              if (!isNaN(n) && n > 0) return n;
            } catch { }


            try {
              const cr = JSON.parse(localStorage.getItem('createReportData') || 'null');
              const n = parseInt(typeof cr?.project_id === 'string' ? cr.project_id.replace(/\D/g, '') : cr?.project_id);
              if (!isNaN(n) && n > 0) return n;
            } catch { }


            {
              const pid = projectDetails.projectId || savedRelayData?.project_id;
              const n = parseInt(typeof pid === 'string' ? pid.replace(/\D/g, '') : pid);
              if (!isNaN(n) && n > 0) return n;
            }

            throw new Error('Could not determine project_id');
          };


          let existingFilename = `Relay_Test_Report_${Date.now()}.docx`;
          if (savedGeneralData?.report_file?.filename) {
            existingFilename = savedGeneralData.report_file.filename;
          } else {
            try {
              const upd = JSON.parse(localStorage.getItem('updateReportData') || 'null');
              if (upd?.report_file?.filename) {
                existingFilename = upd.report_file.filename;
              }
            } catch { }
          }


          const subProjectName = savedGeneralData?.sub_project_name ||
            (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).sub_project_name : "") ||
            projectDetails.subProjectName ||
            savedRelayData?.project ||
            "Project";

          const categoryName = savedGeneralData?.category_name ||
            (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).category_name : "") ||
            projectDetails.categoryName ||
            "Relays";

          const subCategoryName = savedGeneralData?.subcategory_name ||
            (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).subcategory_name : "") ||
            projectDetails.subcategoryName ||
            "Functional Check";

          const equipmentName = savedGeneralData?.equipment_name ||
            (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).equipment_name : "") ||
            projectDetails.equipmentName ||
            savedRelayData?.equipment ||
            "Relays";


          const apiRequestData = {
            report_id: parseInt(reportId),
            equipment_name: String(equipmentName),
            test_date: String(savedRelayData?.date || currentDate),
            category_name: String(categoryName),
            subcategory_name: String(subCategoryName),
            sub_project_name: String(subProjectName),
            project_id: resolveProjectId(),
            location: String(savedRelayData?.location || projectDetails.location || ""),
            report_file: {
              report_word: base64Word,
              filename: existingFilename,
              file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },
            test_data: {
              relayGeneralData: savedRelayData || {},
              relaySettingsData: savedSettingsData || {},
              operationalTimeData: savedOperationalData || {},
              functionalChecksData: finalFunctionalData,
              relays_checkList_Data: finalCheckListData
            }
          };

          console.log("=== Final API Request Data ===");
          console.log("Report ID:", apiRequestData.report_id);
          console.log("Test Data Keys:", Object.keys(apiRequestData.test_data));
          console.log("Functional Checks (array):", apiRequestData.test_data.functionalChecksData);
          console.log("CheckList (array):", apiRequestData.test_data.relays_checkList_Data);


          const apiUrl = `${API_URL}/test_report/update_test_report`;

          const response = await fetch(apiUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(apiRequestData),
            mode: 'cors',
            credentials: 'same-origin',
          });

          console.log("API Response Status:", response.status);

          if (!response.ok) {
            let errorData;
            try {
              errorData = await response.json();
              console.error("Detailed API Error:", errorData);
            } catch (jsonError) {
              const errorText = await response.text();
              console.error("Error response text:", errorText);
              errorData = { message: errorText || response.statusText };
            }

            throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
          }

          const result = await response.json();
          console.log('✓ API Response:', result);

          alert("Data updated successfully!");
          setFormSubmitted(true);

        } catch (error) {
          console.error("❌ Error in processing:", error);
          setErrorMessage(`Error: ${error.message}`);
          alert(`Error saving data: ${error.message}`);
        } finally {
          setIsLoading(false);
        }
      };

      reader.onerror = () => {
        console.error("Error reading Word blob");
        setErrorMessage("Error reading Word document");
        setIsLoading(false);
      };

    } catch (error) {
      console.error("❌ Error in handleSave:", error);

      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else if (error.message.includes("generateWordBlob is not defined")) {
        setErrorMessage("Word document generation function is missing");
        alert("Word document generation function is missing. Please check your imports.");
      } else {
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      }
      setIsLoading(false);
    }
  };

  const generateWordBlob = () => {
    return new Promise((resolve, reject) => {
      try {

        const storedFormData = JSON.parse(localStorage.getItem('updateRelayInspectionData') || '{}');
        const settingsFromStorage = JSON.parse(localStorage.getItem('updateRelaySettingsData') || '{}');
        let operationalTimeData = JSON.parse(localStorage.getItem('updateOperationalTimeData') || '{}');


        try {
          if (window.operationalTimeData && Object.keys(window.operationalTimeData).length > 0) {
            operationalTimeData = window.operationalTimeData;
          } else if (window.formData && Object.keys(window.formData).length > 0) {
            operationalTimeData = window.formData;
          } else if (window.testResults && Object.keys(window.testResults).length > 0) {
            operationalTimeData = window.testResults;
          } else {
            const storageKeys = ['operationalTimeData', 'formData', 'testResults', 'relayData', 'operationalData'];
            for (let key of storageKeys) {
              try {
                const stored = localStorage.getItem(key);
                if (stored) {
                  const parsed = JSON.parse(stored);
                  if (parsed && Object.keys(parsed).length > 0) {
                    operationalTimeData = parsed;
                    break;
                  }
                }
              } catch (e) {
                console.log(`Error parsing ${key}:`, e);
              }
            }
          }
        } catch (e) {
          console.log('Error accessing data:', e);
        }


        const tableBorders = {
          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
        };


        function findValue(data, searchTerms, defaultValue = "N/A") {
          if (!data || typeof data !== 'object') return defaultValue;

          const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];

          for (let term of terms) {
            if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
              return data[term];
            }
          }

          const dataKeys = Object.keys(data);
          for (let term of terms) {
            const termLower = term.toLowerCase();
            for (let key of dataKeys) {
              if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
                return data[key];
              }
            }
          }

          for (let term of terms) {
            const termLower = term.toLowerCase();
            for (let key of dataKeys) {
              if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
                return data[key];
              }
            }
          }

          return defaultValue;
        }

        function getBasicValue(sectionData, fieldSearchTerms, phase) {
          if (!sectionData) return "N/A";

          const phaseSpecificTerms = fieldSearchTerms.map(term => `${term}_${phase}`).concat(
            fieldSearchTerms.map(term => `${term}${phase}`),
            fieldSearchTerms.map(term => `${phase}_${term}`),
            fieldSearchTerms.map(term => `${phase}${term}`)
          );

          let value = findValue(sectionData, phaseSpecificTerms);
          if (value !== "N/A") return value;

          return findValue(sectionData, fieldSearchTerms);
        }


        function getInjectedFromIndex(data, phase, multiplier) {
          if (!data) return 'N/A';


          const fieldMap = {
            '2X': 'injectedCurrent2X',
            '5X': 'injectedCurrent5X',
            '10X': 'injectedCurrent10X'
          };

          const fieldName = fieldMap[multiplier];
          if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
            return data[fieldName];
          }

          return 'N/A';
        }


        function getOperatedFromIndex(data, phase, multiplier) {
          if (!data) return 'N/A';


          const fieldMap = {
            '2X': 'operatedTime2X',
            '5X': 'operatedTime5X',
            '10X': 'operatedTime10X'
          };

          const fieldName = fieldMap[multiplier];
          if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
            return data[fieldName];
          }

          return 'N/A';
        }

        function safeToString(value) {
          if (value === null || value === undefined || value === '' || value === 'N/A') {
            return "";
          }
          return value.toString();
        }


        const fetchImageAsBase64 = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                const base64 = dataURL.split(',')[1];
                resolve(base64);
              } catch (error) {
                console.warn("Could not convert image to base64:", error);
                resolve(null);
              }
            };
            img.onerror = function () {
              console.warn("Could not load image from URL:", url);
              resolve(null);
            };
            img.src = url;
          });
        };


        let sectionDataOC1 = {};
        const oc1Keys = ['oc1', 'OC1', 'O/C 1', 'oc_1', 'OC_1'];
        for (let key of oc1Keys) {
          if (operationalTimeData[key]) {
            sectionDataOC1 = operationalTimeData[key];
            break;
          }
        }

        let sectionDataOC2 = {};
        const oc2Keys = ['oc2', 'OC2', 'O/C 2', 'oc_2', 'OC_2'];
        for (let key of oc2Keys) {
          if (operationalTimeData[key]) {
            sectionDataOC2 = operationalTimeData[key];
            break;
          }
        }

        let sectionDataEF1 = {};
        const ef1Keys = ['ef1', 'EF1', 'E/F 1', 'ef_1', 'EF_1'];
        for (let key of ef1Keys) {
          if (operationalTimeData[key]) {
            sectionDataEF1 = operationalTimeData[key];
            break;
          }
        }

        let sectionDataEF2 = {};
        const ef2Keys = ['ef2', 'EF2', 'E/F 2', 'ef_2', 'EF_2'];
        for (let key of ef2Keys) {
          if (operationalTimeData[key]) {
            sectionDataEF2 = operationalTimeData[key];
            break;
          }
        }


        const createLightWatermark = (base64Data) => {
          return new Promise((resolve) => {
            if (!base64Data) {
              resolve(null);
              return;
            }

            try {
              const img = new Image();
              img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;


                ctx.globalAlpha = 0.15;
                ctx.drawImage(img, 0, 0);

                const lightDataURL = canvas.toDataURL('image/png');
                const lightBase64 = lightDataURL.split(',')[1];
                resolve(lightBase64);
              };
              img.onerror = function () {
                resolve(null);
              };
              img.src = 'data:image/png;base64,' + base64Data;
            } catch (error) {
              console.warn("Could not create light watermark:", error);
              resolve(null);
            }
          });
        };


        const documentSections = [];


        const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
        const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";


        Promise.all([
          fetchImageAsBase64(logoUrl),
          fetchImageAsBase64(watermarkUrl)
        ]).then(([logoBase64, watermarkBase64]) => {


          createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {


            const headerElements = [];

            if (logoBase64) {
              headerElements.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: logoBase64,
                                  transformation: {
                                    width: 80,
                                    height: 80
                                  }
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                            })
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 20, type: WidthType.PERCENTAGE },
                          margins: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "PIE POWER PRIVATE LIMITED",
                                  font: "Times New Roman",
                                  color: "#1e402c",
                                  bold: true,
                                  size: 36
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 80, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ]
                })
              );
            } else {

              headerElements.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "PIE POWER PRIVATE LIMITED",
                      font: "Times New Roman",
                      color: "#1e402c",
                      bold: true,
                      size: 36
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                      font: "helvetica",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                      font: "helvetica",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                })
              );
            }

            headerElements.push(new Paragraph({ text: "" }));
            documentSections.push(...headerElements);





            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "RELAYS INSPECTION / TEST REPORT ", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Date", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(storedFormData?.date), font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Project", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Report No", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Customer", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),

                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Client", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(storedFormData?.client), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );


            documentSections.push(new Paragraph({ text: "" }));



            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "LOCATION:",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  }),
                  new TextRun({
                    text: " " + safeToString(storedFormData?.location),
                    font: "Courier New",

                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));





            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "NAME PLATE DETAILS",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );


            const nameplateFields = [

              { label: "Make", value: storedFormData?.make },
              { label: "Type", value: storedFormData?.type },
              { label: "Serial No", value: storedFormData?.serialNo },
              { label: "Supply Voltage(Uaux)", value: storedFormData?.supplyVoltage },
              { label: "CT Ratio", value: storedFormData?.ctRatio }
            ];

            const nameplateRows = [];

            nameplateFields.forEach(field => {
              nameplateRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.label, font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      width: { size: 50, type: WidthType.PERCENTAGE },
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(field.value), font: "Courier New" })] })],
                      borders: tableBorders,
                      width: { size: 50, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: nameplateRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Current Transformer Measurements",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(Amp)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 40, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Current(Amp)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 40, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseRMeasured || '', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseYMeasured || '', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseBMeasured || '', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({
              children: [new TextRun({ text: "", break: 1 })]
            }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "RELAY SETTINGS",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Parameter", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 1", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 18.75, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 2", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 18.75, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 1", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 18.75, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 2", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 18.75, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ANSI Code", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_ansiCode || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_ansiCode || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_ansiCode || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_ansiCode || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Value", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_setValue || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_setValue || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_setValue || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_setValue || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Curve Type", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_curveType || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_curveType || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_curveType || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_curveType || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TIME", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_time || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_time || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_time || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_time || 'N/A', font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "OPERATIONAL TIME DATA",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: {
                          fill: "a6a6a6"
                        }
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 1", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        verticalAlign: VerticalAlign.CENTER
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TMS", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        columnSpan: 3
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        columnSpan: 3
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 2", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 3
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: {
                  size: 100,
                  type: WidthType.PERCENTAGE,
                },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 1", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "N", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['setTime', 'time', 'tms'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['injected', 'injectedCurrent', 'inject'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['operated', 'operatedTime', 'opTime'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: {
                  size: 100,
                  type: WidthType.PERCENTAGE,
                },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TMS", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        rowSpan: 2
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        columnSpan: 3
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        columnSpan: 3
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      })
                    ]
                  }),

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 2", bold: true, font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "N", bold: true, font: "Courier New" })] })],
                        borders: tableBorders

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF2, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF2, ['tms', 'TMS', 'time'], 'N')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );


            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "FUNCTIONAL CHECKS",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ],
                alignment: AlignmentType.LEFT,
                spacing: { after: 200 }
              })
            );


            documentSections.push(
              new Table({
                width: {
                  size: 100,
                  type: WidthType.PERCENTAGE
                },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({
                          children: [new TextRun({ text: "Check", bold: true, font: "Courier New" })],
                          alignment: AlignmentType.CENTER,

                          shading: {
                            fill: "a6a6a6"
                          }
                        })],
                        borders: tableBorders,
                        width: { size: 70, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
                          alignment: AlignmentType.CENTER
                        })],
                        borders: tableBorders,
                        width: { size: 30, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),


                  ...functionalChecksData.map((check, index) =>
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
                          borders: tableBorders,

                          shading: {
                            fill: "a6a6a6"
                          }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: functionalValues[index] || "N/A", font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    })
                  )
                ]
              })
            );


            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "CHECK LIST",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ],
                alignment: AlignmentType.LEFT,
                spacing: { after: 200 }
              })
            );


            documentSections.push(
              new Table({
                width: {
                  size: 100,
                  type: WidthType.PERCENTAGE
                },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({
                          children: [new TextRun({ text: "Check Point", bold: true, font: "Courier New" })],
                          alignment: AlignmentType.CENTER
                        })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 70, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
                          alignment: AlignmentType.CENTER
                        })],
                        borders: tableBorders,

                        width: { size: 30, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),


                  ...checkListData.map((check, index) =>
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
                          borders: tableBorders,

                          shading: {
                            fill: "a6a6a6"
                          }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: checkListValues[index] || "N/A", font: "Courier New" })] })],

                          borders: tableBorders
                        })
                      ]
                    })
                  )
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));

            const convertInchesToTwip = (inches) => {
              return Math.round(inches * 1440);
            };


            const footerTable = new Table({
              width: { size: 100, type: WidthType.PERCENTAGE, },
              alignment: AlignmentType.LEFT,
              rows: [
                new TableRow({
                  height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "Pie Power",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            }),
                            new SimpleField({
                              instruction: "PAGE",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            }),
                            new SimpleField({
                              instruction: "NUMPAGES",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    })
                  ]
                })
              ]
            });



            const pageBorders = {
              pageBorderTop: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },


              pageBorderRight: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderBottom: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderLeft: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              }
            };

            const doc = new Document({
              sections: [
                {
                  properties: {
                    page: {
                      margin: {
                        top: convertInchesToTwip(0.5),
                        right: convertInchesToTwip(0.5),
                        bottom: convertInchesToTwip(1.0),
                        left: convertInchesToTwip(0.5)
                      },
                      borders: pageBorders,
                      pageNumbers: {
                        start: 1,
                        formatType: NumberFormat.DECIMAL
                      }
                    }
                  },
                  footers: {
                    default: new Footer({
                      children: [
                        footerTable,
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Page ",
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              children: [PageNumber.CURRENT],
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              text: " of ",
                              font: "Courier New",
                              size: 16
                            }),

                            new TextRun({
                              children: [PageNumber.TOTAL_PAGES],
                              font: "Courier New",
                              size: 16
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                          spacing: {
                            before: 200
                          }
                        })
                      ]
                    })
                  },
                  headers: lightWatermarkBase64 ? {
                    default: new Header({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: lightWatermarkBase64,
                              transformation: {
                                width: 500,
                                height: 500
                              },
                              floating: {
                                horizontalPosition: {
                                  relative: HorizontalPositionRelativeFrom.PAGE,
                                  align: HorizontalPositionAlign.CENTER
                                },
                                verticalPosition: {
                                  relative: VerticalPositionRelativeFrom.PAGE,
                                  align: VerticalPositionAlign.CENTER
                                },
                                wrap: {
                                  type: TextWrappingType.BEHIND_TEXT
                                },
                                allowOverlap: true,
                                behindDocument: true
                              }
                            })
                          ]
                        })
                      ]
                    })
                  } : undefined,
                  children: documentSections
                }
              ]
            });



            Packer.toBlob(doc).then(blob => {
              resolve(blob);
            }).catch(error => {
              console.error("Error generating Word blob:", error);
              reject(error);
            });
          });

        }).catch(error => {
          console.error("Error fetching logo:", error);
          reject(error);
        });

      } catch (error) {
        console.error("Error generating Word blob:", error);
        reject(error);
      }
    });
  };






  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {

      const allFormData = JSON.parse(localStorage.getItem('updateRelayInspectionData') || '{}');


      const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;

      const wordBlob = await generateWordBlob(safeFormData, checkListValues);
      saveAs(wordBlob, 'Relay_Inspection_Report.docx');


      localStorage.removeItem('updateRelayInspectionData');


      alert("Word document downloaded successfully");


    } catch (error) {
      console.error("Error generating Word document:", error);
      setErrorMessage(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setShowBackPage(true);
  };

  if (showBackPage) {
    return <RelaysTwoUpdate
      goBack={() => setShowBackPage(false)}
      savedGeneralData={allFormData}
    />;
  }

  return (
    <div className="ct-9107">
      <div className="ct-9107-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>FUNCTIONAL CHECKS</h2>

        <span
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px',
            fontWeight: '600',
            color: '#333',
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>

      </div>

      {errorMessage && (
        <div className="ct-9107-error-message">
          {errorMessage}
        </div>
      )}

      <div className="ct-9107-checks-section">
        {functionalChecksData.map((item, index) => (
          <div className="ct-9107-check-row" key={`func-${index}`}>
            <div className="ct-9107-check-label">{item}</div>
            <div className="ct-9107-check-input">
              <select
                value={functionalValues[index] || ''}
                onChange={(e) => handleFunctionalChange(index, e.target.value)}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="ct-9107-header">
        <h2>CHECK LIST</h2>
      </div>

      <div className="ct-9107-check-point-label">Check Point*</div>


      <div className="ct-9107-checks-section">
        {checkListData.map((item, index) => (
          <div className="ct-9107-check-row" key={`list-${index}`}>
            <div className="ct-9107-check-label">{item}</div>
            <div className="ct-9107-check-input">
              <select
                value={checkListValues[index] || ''}
                onChange={(e) => handleCheckListChange(index, e.target.value)}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="ct-9107-button-container">
        <button type="button" onClick={handleBack} className="ct-9107-back-button" disabled={isLoading}>Back</button>
        <button type="button" className="ct-9107-save-button" onClick={handleSave} disabled={isLoading}>
          {isLoading ? "Processing..." : "Update"}
        </button>

        {formSubmitted && (
          <button
            type="button"
            className="ct-9107-download-button"
            onClick={handleDownloadPDF}
            disabled={isLoading}
            style={{
              marginLeft: '10px',
              backgroundColor: '#4CAF50',
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
          >
            Download Word
          </button>
        )}
      </div>
    </div>
  );
}

export default FunctionalChecks;

